import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { userInfoAnyUsersCacheKey } from "./constants";
import type { GetUserInfoAnyUsersParams, UserInfoAnyUsersResponse } from "./types";

export const getUserInfoAnyUsers = reactQueryFetcherAdapter(
  userInfoAnyUsersCacheKey,
  async (signal, params: GetUserInfoAnyUsersParams): Promise<UserInfoAnyUsersResponse> => {
    return fetch(userInfoAnyUsersCacheKey, "GET", params, { signal });
  }
);
